import { upsertInformalFeedbackRequests, upsertInformalFeedbackRequest } from 'redux/actions/informalFeedbackRequests'
import { upsertReview } from 'redux/actions/reviews'
import { upsertFetchRequest } from 'redux/actions/articleInformalFeedbackRequestsFetchRequests'
import { FetchRequestState } from 'types'
import { Store } from 'redux'
import {
  InformalFeedbackRequestsClient,
  CreateInformalFeedbackRequestInput,
  UpdateInformalFeedbackRequestInput,
  QueryOptions,
  ExternalResourceInput,
} from 'api/clients/InformalFeedbackRequestsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { articleMetaSet } from 'redux/actions'
import { QueryClient } from 'react-query'
import { informalFeedbackRequestsKeys } from '../../hooks/queries/informalFeedbackRequests/informalFeedbackRequestsKeys'

export const InformalFeedbackRequestsService = {
  index: async (store: Store, articleKey: string, layerId?: string, options?: QueryOptions) => {
    store.dispatch(upsertFetchRequest(articleKey, FetchRequestState.Loading))
    const res = await InformalFeedbackRequestsClient.index(articleKey, layerId, options)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertInformalFeedbackRequests(res.data.informal_feedback_requests))
      store.dispatch(upsertFetchRequest(articleKey, FetchRequestState.Resolved))
    } else {
      store.dispatch(upsertFetchRequest(articleKey, FetchRequestState.Rejected))
    }

    return res
  },

  show: async (store: Store, id: number, queryClient?: QueryClient) => {
    const res = await InformalFeedbackRequestsClient.show(id)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.detail(request.id))
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
    }

    return res
  },

  // Allow articleKey to be undefined to indicate that the review's article needs to be created too
  create: async (
    store: Store,
    workspaceId: number,
    articleKey: string | undefined,
    input: CreateInformalFeedbackRequestInput & { asset?: ExternalResourceInput },
    asset?: ExternalResourceInput,
    queryClient?: QueryClient,
  ) => {
    const res = articleKey
      ? await InformalFeedbackRequestsClient.create(articleKey, input)
      : // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await InformalFeedbackRequestsClient.createForAsset(workspaceId, asset!, input)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.list(request.article.key, request.layer?.id))
      const articleMeta = store.getState().articleMeta[request.article.key] || {}
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
      store.dispatch(
        articleMetaSet({
          ...articleMeta,
          workflow_status: { state: 'informal_feedback_request', text: 'In feedback' },
        }),
      )
    }

    return res
  },

  update: async (
    store: Store,
    id: number,
    input: UpdateInformalFeedbackRequestInput,
    queryClient?: QueryClient,
    password?: string | null,
  ) => {
    const res = await InformalFeedbackRequestsClient.update(id, input)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const request = res.data.informal_feedback_request
      queryClient?.invalidateQueries(informalFeedbackRequestsKeys.list(request.article.key, request.layer?.id))
      store.dispatch(upsertInformalFeedbackRequest(request))
      store.dispatch(upsertReview(request))
    }

    return res
  },
}
